import { List } from '@zxing/library/esm/customTypings';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { SupplementaryEquipmentDetails, SupplementaryEquipmentIdentifier } from '../../model/supplementary-equipment-details';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from '@sdbn/common';


@Component({
    selector: 'app-equipment-identifier',
    templateUrl: './equipment-identifier.component.html',
    styleUrls: ['./equipment-identifier.component.scss'],
    standalone: false
})
export class EquipmentIdentifierComponent implements OnInit {

  @Input() selectedDetails: SupplementaryEquipmentDetails;

  @Output() deleteClicked = new EventEmitter<SupplementaryEquipmentIdentifier>();

  @Output() changeActiveClicked = new EventEmitter<SupplementaryEquipmentIdentifier>();

  @Output() addNewIdentifierClicked = new EventEmitter<SupplementaryEquipmentIdentifier>();


  identifiers: List<SupplementaryEquipmentIdentifier>;

  identifiersForm: FormGroup;

  newIdentifier: string;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedDetails == null) {
      return;
    }
    this.identifiers = changes.selectedDetails.currentValue.identifiers ?? new Array<SupplementaryEquipmentIdentifier>();;
  }


  constructor(
    private dialog: MatDialog,
    private dialogService: DialogService
  ) {
    this.identifiersForm = new FormGroup({
      newIdentifier: new FormControl("", [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.identifiers = this.selectedDetails.identifiers ?? new Array<SupplementaryEquipmentIdentifier>();

    this.identifiersForm.valueChanges.subscribe(value => {
      this.newIdentifier = value.newIdentifier;
    }
    );
  }

  changeActive(identifier: SupplementaryEquipmentIdentifier) {
    identifier.active = !identifier.active;
    this.changeActiveClicked.emit(identifier);

  }

  delete(
    identifier: SupplementaryEquipmentIdentifier
  ) {

    this.dialogService.showConfirm(
      'tmc.admin.supplementary-equipment.delete.confirm-dialog.title',
      'tmc.admin.supplementary-equipment.delete.confirm-dialog.message'
    ).afterClosed().subscribe(confirm => {
      if (confirm) {
        this.identifiers = this.identifiers.filter((oldIdentifier) => oldIdentifier.identifier != identifier.identifier);
        console.log(identifier, this.identifiers)
        this.deleteClicked.emit(identifier);
      }
    });

  }

  addNewIdentifier() {
    const newIdentifier = new SupplementaryEquipmentIdentifier({
      active: true,
      identifier: this.newIdentifier,
    });

    this.identifiers.push(newIdentifier);

    this.addNewIdentifierClicked.emit(newIdentifier);

    this.identifiersForm.reset();
  }

  addNewEnabled() {
    return this.identifiersForm.valid;
  }
}


